import React, { useEffect, useState } from 'react';
// import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { State, City } from 'country-state-city';

import Lottie from 'react-lottie';
import clsx from 'clsx';
import {
  Typography,
  Grid,
  Button,
  makeStyles,
  Hidden,
  CircularProgress,
  CardMedia,
} from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import MuiPhoneNumber from 'material-ui-phone-number';
import { useDispatch, useSelector } from 'react-redux';
import loaderAnimation from '../../images/loader.json';

import { SingleDialog, DialogContent } from '../CustomDialogs';
import { wizard } from '../../actions/users/wizard-actions';
import { getSubscriptionPlans } from '../../actions/subscription/subscription-actions';
import Currency from '../Currency';
import SelectBox from '../SelectBox';
import TextFieldComp from '../TextFieldComp';
import TimeZone from '../TimeZone';
import CountiesData from '../Countries';

import { LeadFormImg, UploadFileLogo } from '../../constants';
import './scss/index.scss';
import {
  toBase64,
  uploadBusinessProfileImageToS3,
  handleNumbers,
} from '../Utils/helper';
import { Toast } from '../Toast/Toast';

const useStyles = makeStyles((theme) => ({
  new__onboarding__dialog: {
    width: '80%',
    height: '85vh',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%',
      width: '90%',
    },
  },
  onboarding__dialog__content: {
    height: '100%',
  },
  new__template__dialog__header: { padding: '1.5rem' },
  new__template__dialog__contetn: { padding: '1.5rem' },
  height__100: {
    height: '100%',
  },
  padding__right: {
    paddingRight: '0.8rem',
    paddingBottom: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0',
    },
  },
  padding__left: {
    paddingLeft: '0.8rem',
    paddingBottom: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
    },
  },
  input__label: {
    fontSize: '13px',
    color: '#545B7D',
    lineHeight: '16px',
    fontWeight: 'normal',
  },
  is__error: {
    color: '#E53935 !important',
  },
  user__photo: {
    width: '80px !important',
    height: '80px !important',
    borderRadius: '100px !important',
  },
}));

const Onboarding = ({ toggle, setToggle }) => {
  let userData = JSON.parse(localStorage.getItem('userData'));
  const [activeSlide, setActiveSlide] = useState(0);
  const classes = useStyles();
  const dispatch = useDispatch();

  // const stripe = useStripe();
  // const elements = useElements();

  const plans = useSelector((state) => state.subscription?.plans || []);

  const { error = '' } = useSelector((state) => state.wizard);

  // const [cardDetails, setCardDetails] = useState({
  //   cardHolderName: '',
  // });

  // const [requiredFields, setRequiredFields] = useState({
  //   cardHolderName: '',
  // });

  const [loading, setLoading] = useState(false);
  const [countries] = useState(CountiesData);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  // const [createPmLoading, setCreatePmLoading] = useState(false);

  const [onBoardValues, setOnBoardValues] = useState({
    profileImg: '',
    profileImgFile: '',
    businessName: '',
    ownerName: '',
    mobileNum: '',
    address: '',
    email: '',
    country: '',
    state: '',
    city: '',
    zip: '',
    currency: '97.$',
    timeZone: 'America/California',
    laborClass: 15.5,
    taxClass: 7.25,
    subscriptionId: null,
  });

  const [errors, setErrors] = useState({
    businessName: false,
    ownerName: false,
    mobileNum: false,
    email: false,
    currency: false,
    timeZone: false,
    laborClass: false,
    taxClass: false,
    subscriptionId: false,
    country: false,
    state: false,
    city: false,
    zip: false,
  });

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loaderAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  // set default plan
  useEffect(() => {
    if (plans?.length) {
      const planValue = plans?.find((p) => p.isDefault === true);
      if (planValue?.value) {
        setOnBoardValues({ ...onBoardValues, subscriptionId: planValue.value });
      }
    }
  }, [plans]);

  useEffect(() => {
    // setIsOtherService(false);
    // setServices([]);
    if (userData?.email || userData?.userName || userData?.subscriptionId) {
      setOnBoardValues({
        ...onBoardValues,
        ownerName: userData?.userName,
        email: userData?.email,
        subscriptionId: userData?.subscriptionId || null,
      });
    }

    dispatch(getSubscriptionPlans());
  }, []);

  // useEffect(() => {
  //   setCountries(Country.getAllCountries());
  // }, []);

  const validateBusinessFields = (values) => {
    const errorsObj = {};
    const emailRgx = /^\S+@\S+\.\S+$/;
    let isValid = true;

    if (!values.businessName?.trim()?.length) {
      isValid = false;
      errorsObj.businessName = true;
    }

    if (!values.address?.trim()?.length) {
      isValid = false;
      errorsObj.address = true;
    }

    if (values?.businessName && values?.businessName?.length > 40) {
      isValid = false;
      errorsObj.businessName = true;
    }
    if (!values.ownerName?.trim()?.length) {
      isValid = false;
      errorsObj.ownerName = true;
    }
    if (values?.ownerName && values?.ownerName?.length > 40) {
      isValid = false;
      errorsObj.ownerName = true;
    }
    if (!values.mobileNum?.trim()?.length) {
      isValid = false;
      errorsObj.mobileNum = true;
    }
    if (!values.country) {
      isValid = false;
      errorsObj.country = true;
    }
    if (!values.state) {
      isValid = false;
      errorsObj.state = true;
    }
    if (!values.zip?.trim()?.length) {
      isValid = false;
      errorsObj.zip = true;
    }
    if (!values.city) {
      isValid = false;
      errorsObj.city = true;
    }
    if (
      values?.mobileNum
        ?.trim()
        .split(' ')
        .join('')
        .split(')')
        .join('')
        .split('(')
        .join('')
        .split('-')
        .join('').length < 12
    ) {
      isValid = false;
      errorsObj.mobileNum = true;
    }
    if (!values.email?.trim()?.length) {
      errorsObj.email = true;
    }

    if (values.email) {
      const isValidEmail = emailRgx.test(values.email);
      if (!isValidEmail) {
        isValid = false;
        errorsObj.email = true;
      }
    }
    if (!values.currency) {
      isValid = false;
      errorsObj.currency = true;
    }

    if (!userData?.subscriptionId?.trim()) {
      if (!values.subscriptionId) {
        isValid = false;
        errorsObj.subscriptionId = true;
      }
    }
    if (!values.timeZone) {
      isValid = false;
      errorsObj.timeZone = true;
    }

    if (!values.laborClass) {
      isValid = false;
      errorsObj.laborClass = true;
    }
    if (!values.taxClass) {
      isValid = false;
      errorsObj.taxClass = true;
    }

    setErrors({ ...errorsObj });
    return isValid;
  };

  const getStates = (countryCode) => {
    setStates(State.getStatesOfCountry(countryCode));
  };

  const getCities = (stateCode) => {
    const { country } = onBoardValues;
    setCities(City.getCitiesOfState(country, stateCode));
  };

  const handleChange = (event, isMobileField) => {
    if (isMobileField) {
      setOnBoardValues({ ...onBoardValues, ['mobileNum']: event });
      setErrors({ ...errors, mobileNum: false });
    } else {
      const { name, value } = event.target;
      if (name === 'taxClass' || name === 'laborClass') {
        const roundedValue = handleNumbers(value);
        setErrors({ ...errors, [name]: false });
        setOnBoardValues({
          ...onBoardValues,
          [name]: roundedValue,
        });
      } else {
        if (name === 'country') {
          getStates(value);
        }
        if (name === 'state') {
          getCities(value);
        }
        setErrors({ ...errors, [name]: false });
        setOnBoardValues({
          ...onBoardValues,
          [name]: value,
        });
      }
    }
  };

  const handleImage = async (e) => {
    const files = e.target.files[0];

    if (!files) return;

    const fileType = files?.type || '';
    const fileSize = files?.size || '';
    let isValid = false;
    let errorMessage = '';
    if (
      fileType === 'image/jpeg' ||
      fileType === 'image/jpg' ||
      fileType === 'image/png'
    ) {
      if (fileSize <= 5000000) {
        // 5MB =  5000000 Bytes
        isValid = true;
      } else {
        errorMessage =
          'The image file exceeds the 5MB limit. Please upload a smaller image.';
      }
    } else {
      errorMessage =
        "Please Select only Images of type: 'PNG', 'JPG', 'JPEG' '";
    }

    if (isValid) {
      const imageBase64 = await toBase64(files);

      let file = '';

      try {
        file = new File([files], 'image', {
          type: 'image/png',
        });
      } catch {
        file = files;
      }

      setOnBoardValues({
        ...onBoardValues,
        profileImg: imageBase64,
        profileImgFile: file,
      });
    } else {
      Toast('error', errorMessage);
    }
  };

  // const handlePaymentValidation = () => {
  //   let err = false;
  //   const erros = {};

  //   // checking the required validation
  //   if (cardDetails.cardHolderName?.length < 1) {
  //     err = true;
  //     erros['cardHolderName'] = true;
  //   } else {
  //     erros['cardHolderName'] = false;
  //   }

  //   setRequiredFields({ ...erros });
  //   return err;
  // };

  // const createStripePaymentMethod = async () => {
  //   if (!stripe || !elements) {
  //     // Stripe.js has not yet loaded.
  //     return;
  //   }
  //   const cardElement = elements.getElement(CardElement);

  //   if (!cardElement) return '';

  //   setCreatePmLoading(true);

  //   const { error: err, paymentMethod } = await stripe.createPaymentMethod({
  //     type: 'card',
  //     card: cardElement,
  //     billing_details: {
  //       name: cardDetails?.cardHolderName || '',
  //     },
  //   });
  //   setCreatePmLoading(false);

  //   if (err) {
  //     console.log('[err]', err);
  //     Toast('error', err.message);
  //   }
  //   return paymentMethod;
  // };

  const onStart = async () => {
    // const cardError = handlePaymentValidation(cardDetails);

    // if (cardError) {
    //   Toast('error', 'Card Holder Name is required');
    //   return;
    // }

    // const cardData = await createStripePaymentMethod();

    // if (!cardData?.id) return;

    if (!validateBusinessFields(onBoardValues)) return;

    setLoading(true);
    setActiveSlide((prev) => prev + 1);

    let businessProfileImg = userData?.userStore?.profileImg || '';

    if (onBoardValues.profileImgFile) {
      const res = await uploadBusinessProfileImageToS3(
        onBoardValues.profileImgFile,
      );
      if (res?.location) {
        businessProfileImg = res.location;
      }
    }

    delete onBoardValues.profileImgFile;
    await dispatch(
      wizard({
        ...onBoardValues,
        profileImg: businessProfileImg,
        documentBranding:
          onBoardValues?.businessName + ' - ' + onBoardValues?.mobileNum,
      }),
    );

    setLoading(false);
  };

  // const handleChangeCardHolderName = async (e) => {
  //   const { name, value } = e.target;

  //   if (value?.length > 25) {
  //     return;
  //   }

  //   if (value?.length > 0 && requiredFields?.cardHolderName) {
  //     setRequiredFields({ ...requiredFields, [name]: false });
  //   }

  //   setCardDetails({ ...cardDetails, [name]: value });
  // };
  // onboarding error case

  useEffect(() => {
    if (error) {
      Toast('error', error);
      setLoading(false);

      dispatch({ type: 'CLEAR_USER_WIZARD_STATE' });

      setActiveSlide(0);

      if (error === 'Please select you subsription plan') {
        userData.subscriptionId = null;
        userData = JSON.stringify(userData);
        localStorage.setItem('userData', userData);

        setOnBoardValues({
          ...onBoardValues,
          subscriptionId: null,
        });
        setErrors({
          ...errors,
          subscriptionId: true,
        });
      }
    }
  }, [error]);

  const slides = {
    0: (
      <div className='upper__content'>
        <Hidden mdUp>
          <Typography className='heading'>Welcome </Typography>
          <Typography className='semi__heading'>
            Setup Your Torque360 Account
          </Typography>
        </Hidden>
        <div className='media__onboarding'>
          <label>
            <input
              accept='image/png, image/jpg, image/jpeg,'
              type='file'
              hidden
              name='profileImg'
              onChange={handleImage}
            />

            <CardMedia
              classes={{
                root: classes.user__photo,
              }}
              image={onBoardValues.profileImg}
            >
              {!onBoardValues.profileImg ? (
                <UploadFileLogo className='upload__image__large' />
              ) : (
                ''
              )}
            </CardMedia>
          </label>

          <div className='label'>
            <Typography className='min__label'>Add Business Logo</Typography>
            <Typography className='link__label'>Upload Image</Typography>
          </div>
        </div>
        <Grid container>
          <Grid item xs={12} md={6} className={classes.padding__right}>
            <TextFieldComp
              label='Business Name*'
              placeholder='Enter Business Name'
              name='businessName'
              value={onBoardValues?.businessName}
              onChange={(e) => handleChange(e)}
              disable={loading}
              error={errors?.businessName}
            />
          </Grid>

          {!userData?.subscriptionId?.trim() ? (
            <Grid
              item
              xs={12}
              md={6}
              className={clsx('onboarding__dropdown', classes.padding__left)}
            >
              <SelectBox
                className='selectCurrencyDropdown settings__profile__from_field'
                inputlabel={
                  errors?.subscriptionId
                    ? `${classes.is__error} settings__profile__inputLabel`
                    : 'settings__profile__inputLabel'
                }
                htmlFor='Subscription'
                labeltext='Set Subscription Plan'
                id='subscriptionId'
                name='subscriptionId'
                disabled={loading}
                value={onBoardValues?.subscriptionId || ''}
                onChange={(e) => handleChange(e)}
                error={errors?.subscriptionId}
                placeholder='Select from list'
                fullWidth
                from_field='settings__profile__from_field'
                options={[{ label: 'Select Plan', value: null }, ...plans]}
              />
            </Grid>
          ) : (
            ''
          )}

          <Grid item xs={12} md={6} className={classes.padding__right}>
            <TextFieldComp
              label='Owner Name*'
              placeholder='Enter Owner Name'
              name='ownerName'
              disable={loading}
              value={onBoardValues?.ownerName}
              onChange={(e) => handleChange(e)}
              error={errors?.ownerName}
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.padding__left}>
            {/* <label className={classes.input__label} htmlFor='mobileNum'>
                      Mobile Number *
                    </label> */}
            <label
              className={clsx(
                classes.input__label,
                errors?.mobileNum && classes.is__error,
              )}
              htmlFor='mobileNum'
            >
              Business Number*
            </label>
            <MuiPhoneNumber
              className='form__field__settings'
              id='mobileNum'
              disabled={loading}
              countryCodeEditable={false}
              defaultCountry='us'
              name='mobileNum'
              value={onBoardValues?.mobileNum}
              onChange={(e) => handleChange(e, true)} // true for specify mobile field
              error={errors?.mobileNum}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.padding__right}>
            <TextFieldComp
              label='Business Address*'
              disable={loading}
              name='address'
              placeholder='Enter Business Address'
              value={onBoardValues?.address}
              onChange={(e) => handleChange(e)}
              error={errors?.address}
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.padding__left}>
            <TextFieldComp
              label='Email*'
              disable={loading || userData?.fbID || userData?.googleID}
              name='email'
              placeholder='Enter Email'
              value={onBoardValues?.email}
              onChange={(e) => handleChange(e)}
              error={errors?.email}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            className={clsx('onboarding__dropdown', classes.padding__right)}
          >
            <SelectBox
              className='selectCurrencyDropdown settings__profile__from_field'
              inputlabel={
                errors?.country
                  ? `${classes.is__error} settings__profile__inputLabel`
                  : 'settings__profile__inputLabel'
              }
              htmlFor='timeZone'
              labeltext='Country'
              id='timeZone'
              disabled={loading}
              name='country'
              value={onBoardValues?.country}
              onChange={(e) => handleChange(e)}
              error={errors?.country}
              placeholder='Select from list'
              fullWidth
              from_field='from_field'
              options={countries}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            className={clsx('onboarding__dropdown', classes.padding__left)}
          >
            <SelectBox
              className='selectCurrencyDropdown settings__profile__from_field'
              inputlabel={
                errors?.state
                  ? `${classes.is__error} settings__profile__inputLabel`
                  : 'settings__profile__inputLabel'
              }
              htmlFor='timeZone'
              labeltext='State'
              id='timeZone'
              disabled={loading}
              name='state'
              value={onBoardValues?.state}
              onChange={(e) => handleChange(e)}
              error={errors?.state}
              placeholder='Select from list'
              fullWidth
              from_field='from_field'
              options={states}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            className={clsx('onboarding__dropdown', classes.padding__right)}
          >
            <SelectBox
              className='selectCurrencyDropdown settings__profile__from_field'
              inputlabel={
                errors?.city
                  ? `${classes.is__error} settings__profile__inputLabel`
                  : 'settings__profile__inputLabel'
              }
              htmlFor='timeZone'
              labeltext='City'
              id='timeZone'
              disabled={loading}
              name='city'
              value={onBoardValues?.city}
              onChange={(e) => handleChange(e)}
              error={errors?.city}
              placeholder='Select from list'
              fullWidth
              from_field='from_field'
              options={cities}
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.padding__left}>
            <TextFieldComp
              label='Zip*'
              disable={loading}
              name='zip'
              placeholder='Enter Zip'
              value={onBoardValues?.zip}
              onChange={(e) => handleChange(e)}
              error={errors?.zip}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            className={clsx('onboarding__dropdown', classes.padding__right)}
          >
            <SelectBox
              className='selectCurrencyDropdown settings__profile__from_field'
              inputlabel={
                errors?.currency
                  ? `${classes.is__error} settings__profile__inputLabel`
                  : 'settings__profile__inputLabel'
              }
              htmlFor='currency'
              labeltext='Set Currency'
              id='currency'
              name='currency'
              disabled={loading}
              value={onBoardValues?.currency}
              onChange={(e) => handleChange(e)}
              error={errors?.currency}
              placeholder='Select from list'
              fullWidth
              from_field='settings__profile__from_field'
              options={Currency}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            className={clsx('onboarding__dropdown', classes.padding__left)}
          >
            <SelectBox
              className='selectCurrencyDropdown settings__profile__from_field'
              inputlabel={
                errors?.timeZone
                  ? `${classes.is__error} settings__profile__inputLabel`
                  : 'settings__profile__inputLabel'
              }
              htmlFor='timeZone'
              labeltext='Set Time Zone'
              id='timeZone'
              disabled={loading}
              name='timeZone'
              value={onBoardValues?.timeZone}
              onChange={(e) => handleChange(e)}
              error={errors?.timeZone}
              placeholder='Select from list'
              fullWidth
              from_field='from_field'
              options={TimeZone}
            />
          </Grid>

          <Grid item xs={12} md={6} className={classes.padding__right}>
            <TextFieldComp
              label='Labor Rate*'
              placeholder='0'
              name='laborClass'
              type='number'
              disable={loading}
              value={onBoardValues?.laborClass}
              onChange={(e) => handleChange(e)}
              error={errors?.laborClass}
              startAdorn='$'
            />
          </Grid>

          <Grid item xs={12} md={6} className={classes.padding__left}>
            <TextFieldComp
              label='Tax*'
              placeholder='0'
              name='taxClass'
              type='number'
              disable={loading}
              value={onBoardValues?.taxClass}
              onChange={(e) => handleChange(e)}
              error={errors?.taxClass}
              endAdor='%'
            />
          </Grid>
        </Grid>
      </div>
    ),
    1: (
      <div className='slide2_loading_popup flex-center h-100'>
        <div className='slide2_loading_popup_box'>
          <div className='slide2_loading_popup_circle'>
            <Lottie options={defaultOptions} height={100} width={100} />
          </div>
          <h3 className='text-center'>We are setting up your account!</h3>
        </div>
      </div>
    ),
  };

  // const handleNext = () => {
  //   let slide1Validation = true;

  //   if (activeSlide === 0) {
  //     slide1Validation = validateBusinessFields(onBoardValues);
  //   }

  //   if (slide1Validation) {
  //     if (activeSlide >= 1) {
  //       return false;
  //     }
  //     setActiveSlide((prev) => prev + 1);
  //   }
  // };

  const handleBack = () => {
    if (activeSlide <= 0) {
      return false;
    }
    setActiveSlide((prev) => prev - 1);
  };
  return (
    <>
      <SingleDialog
        toggle={toggle}
        setToggle={setToggle}
        styles={clsx(
          classes.new__onboarding__dialog,
          'new__onboarding__dialog',
        )}
      >
        {loading ? (
          slides[1]
        ) : (
          <DialogContent
            mainStyles={classes.onboarding__dialog__content}
            displayCenter={classes.height__100}
          >
            <Grid container className='onboarding__dialog__content'>
              <Hidden smDown>
                <Grid item md={4} className='onboarding__sidebar'>
                  <Typography className='heading'>Welcome </Typography>
                  <Typography className='semi__heading'>
                    Setup Your Torque360 Account
                  </Typography>
                  <LeadFormImg className='side_img' />
                </Grid>
              </Hidden>
              <Grid item md={8} className='onboarding__content'>
                <SwipeableViews index={activeSlide}>
                  <div>{slides[activeSlide]}</div>
                  {/* <div className='upper__content'>
                    <h4 className='slide__title'>Add Payment Details</h4>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      className={classes.padding__right}
                    >
                      <TextFieldComp
                        id='cardHolderName'
                        name='cardHolderName'
                        label='Card Holder Name*'
                        placeholder='Enter Name'
                        value={cardDetails.cardHolderName}
                        onChange={handleChangeCardHolderName}
                        error={requiredFields?.cardHolderName}
                      />
                    </Grid>
                    <CardSection />
                  </div> */}
                </SwipeableViews>

                <Grid
                  item
                  xs={12}
                  className={clsx(
                    classes.padding__right,
                    'main__actions',
                    loading && 'space__between',
                  )}
                >
                  {loading && (
                    <div className='wait__text'>
                      Your account is being setup. Please wait, this may take a
                      few moments.
                    </div>
                  )}

                  {activeSlide > 0 ? (
                    <>
                      <Button
                        className='action__btns bg-primary'
                        onClick={handleBack}
                        // disabled={createPmLoading}
                      >
                        Back
                      </Button>
                      <Button
                        className='action__btns bg-primary'
                        onClick={onStart}
                        disabled={
                          loading
                          // || createPmLoading
                        }
                      >
                        Start
                        {loading && (
                          //  || createPmLoading
                          <CircularProgress
                            size={13}
                            color='white'
                            style={{ marginLeft: 10 }}
                          />
                        )}
                      </Button>
                    </>
                  ) : (
                    <Button
                      className={`action__btns ${
                        activeSlide < 1 ? 'bg-primary' : 'bg-light-grey'
                      }`}
                      // onClick={handleNext}
                      onClick={onStart}
                    >
                      {/* Next */}
                      Start
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        )}
      </SingleDialog>
    </>
  );
};
export default Onboarding;
